module.exports = __webpack_public_path__ + "img/ep-login-bg.9fe9eacb.jpg";